import React from "react";

const NoRoomSelected = props => {
  return (
    <div className="message-list">
      <div className="join-room"></div>
    </div>
  );
};

export default NoRoomSelected;


// WEBPACK FOOTER //
// ./src/components/NoRoomSelected.js